"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initRio = initRio;
exports.setRioConfig = setRioConfig;
exports.reset = reset;

require("core-js/features/promise");

require("regenerator-runtime/runtime");

var _configPlugin = require("@chegg-web-tools/config-plugin");

var _rioSdkWeb = require("@chegg/rio-sdk-web");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var $getRioConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", null);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function $getRioConfig() {
    return _ref.apply(this, arguments);
  };
}();

var initialized = false;

function initRio() {
  return _initRio.apply(this, arguments);
}

function _initRio() {
  _initRio = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var rioConfig, dynamicConfig;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(0, _configPlugin.getConfig)('dev_mode')) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            if ('addEventListener' in global) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return");

          case 4:
            if (!initialized) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            rioConfig = (0, _configPlugin.getConfig)('rioConfig');
            _context3.next = 9;
            return $getRioConfig();

          case 9:
            dynamicConfig = _context3.sent;

            if (!(!rioConfig && !dynamicConfig)) {
              _context3.next = 12;
              break;
            }

            return _context3.abrupt("return");

          case 12:
            if (!initialized) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return");

          case 14:
            rioConfig.cheggUuid = getUuid();
            (0, _rioSdkWeb.getClient)().init(_objectSpread(_objectSpread({}, rioConfig), dynamicConfig));
            initialized = true;

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _initRio.apply(this, arguments);
}

function getUuid() {
  try {
    return JSON.parse(atob(document.cookie.split('; ').filter(function (c) {
      return c.substr(0, 8) === 'id_token';
    })[0].split('.')[1])).sub;
  } catch (error) {
    return;
  }
}

function setRioConfig(provider) {
  $getRioConfig = provider;
}

function reset() {
  initialized = false;

  $getRioConfig = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", null);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function $getRioConfig() {
      return _ref2.apply(this, arguments);
    };
  }();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-rio/dist/index.js
// module id = 5689
// module chunks = 11